import React from "react"
import Layout from "../layout/Layout"
import SEO from "../components/seo"
import PageHeaderTitle from "../components/PageHeaderTitle/PageHeaderTitle"
import AboutSection from "../components/AboutSection/AboutSection"

const GuidePage = () => (
  <Layout>
    <SEO title="Więcej o firmie NDA" ratingCount={12} ratingValue={4.9} />
    <PageHeaderTitle text="Więcej o firmie NDA" />
    <AboutSection />
  </Layout>
)

export default GuidePage
